import { render } from "./TableGroup.vue?vue&type=template&id=21793de8"
import script from "./TableGroup.vue?vue&type=script&lang=js"
export * from "./TableGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__